import { createContext, useState } from "react";

interface ModalOptionData {
  name: string;
  [k: string]: any;
}

export interface ModalsContextValue {
  modalData: ModalOptionData;
  openModal: (modalData: ModalOptionData) => void;
  closeModal: () => void;
}

const initialData = {
  modalData: {
    name: "",
  },
  openModal: () => {},
  closeModal: () => {},
};

export const useModalsContext = (): ModalsContextValue => {
  const [modalsContext, setModalsContext] = useState<ModalsContextValue>(initialData);

  const openModal = (modalData: ModalOptionData) => {
    setModalsContext({ ...modalsContext, modalData });
  };

  const closeModal = () => {
    setModalsContext({ ...modalsContext, modalData: { name: "" } });
  };

  return { ...modalsContext, openModal, closeModal };
};

export const ModalsContext = createContext<ModalsContextValue>(initialData);
